<template>
    <section class="bg-white py-20 sm:py-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mb-14">
                <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">FAQs</span>
                <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-[#17364a] tracking-tight">
                    Frequently Asked Questions
                </h2>
            </div>

            <div class="max-w-3xl">
                <div
                    v-for="faq in faqs"
                    :key="faq.id"
                    class="border-b border-[#E5E5E5] last:border-0"
                >
                    <button
                        class="w-full flex items-center justify-between py-5 text-left gap-4 focus:outline-none group"
                        @click="toggleAccordion(faq)"
                    >
                        <span
                            :class="[
                                'text-sm font-semibold transition-colors',
                                faq.active ? 'text-[#A07830]' : 'text-[#17364a] group-hover:text-[#A07830]'
                            ]"
                        >
                            {{ faq.question }}
                        </span>
                        <span
                            :class="[
                                'shrink-0 text-xl font-light transition-colors',
                                faq.active ? 'text-[#A07830]' : 'text-gray-400'
                            ]"
                        >
                            {{ faq.active ? '&minus;' : '+' }}
                        </span>
                    </button>
                    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                        <div v-show="faq.active" class="overflow-hidden">
                            <p class="pb-5 text-sm text-gray-500 leading-relaxed">{{ faq.answer }}</p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';
import { getFaqs } from '@/services/faqService';

const faqs = ref([]);

const fetchFaqs = async () => {
    try {
        const response = await getFaqs();
        faqs.value = response.data;
    } catch {}
};
fetchFaqs();

const toggleAccordion = (faq) => {
    faqs.value.forEach((item) => {
        item.active = item.id === faq.id ? !item.active : false;
    });
};

const beforeEnter = (el) => { el.style.height = '0'; };
const enter = (el) => { el.style.transition = 'height 0.3s ease'; el.style.height = el.scrollHeight + 'px'; };
const beforeLeave = (el) => { el.style.height = el.scrollHeight + 'px'; };
const leave = (el) => { el.style.transition = 'height 0.3s ease'; el.offsetHeight; el.style.height = '0'; };
</script>
